import type React from 'react'
import type { SVGProps } from 'react'

type Props = {
  className?: string
  size?: number
} & SVGProps<SVGSVGElement>

const IconTrash: React.FC<Props> = ({ className, size, ...props }) => {
  const width = size ? `${size}px` : 'fit-content'
  return (
    <svg
      {...props}
      style={{ width }}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8594 3.21875C14.2402 3.21875 14.5625 3.54102 14.5625 3.92188C14.5625 4.33203 14.2402 4.625 13.8594 4.625H13.5078L12.8047 14.1465C12.7168 15.1426 11.9258 15.875 10.9297 15.875H5.04102C4.04492 15.875 3.25391 15.1426 3.16602 14.1465L2.46289 4.625H2.14062C1.73047 4.625 1.4375 4.33203 1.4375 3.92188C1.4375 3.54102 1.73047 3.21875 2.14062 3.21875H4.16211L5.24609 1.60742C5.53906 1.16797 6.06641 0.875 6.62305 0.875H9.34766C9.9043 0.875 10.4316 1.16797 10.7246 1.60742L11.8086 3.21875H13.8594ZM6.62305 2.28125C6.53516 2.28125 6.44727 2.33984 6.41797 2.39844L5.86133 3.21875H10.1094L9.55273 2.39844C9.52344 2.33984 9.43555 2.28125 9.34766 2.28125H6.62305ZM12.1016 4.625H3.86914L4.57227 14.0586C4.60156 14.293 4.80664 14.4688 5.04102 14.4688H10.9297C11.1641 14.4688 11.3691 14.293 11.3984 14.0586L12.1016 4.625Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconTrash
